$(document).ready(function() {

    $('.touch li.megadropdown').click(function() {
     $(this).toggleClass('open');
    });

    // Unite Gallery initialisieren
    if ($("#unitegallery-wide").length) {
        $("#unitegallery-wide").unitegallery({
            tiles_justified_row_height: 200,
            tiles_type: "justified",
            tiles_justified_space_between: 0
        });
    }

    /*
    Double Tap to Go
    Author: Graffino (http://www.graffino.com)
    Version: 0.3
    Originally by Osvaldas Valutis, www.osvaldas.info
    Available for use under the MIT License
    */
    ;(function($, window, document, undefined) {
        $.fn.doubleTapToGo = function(action) {

            if (!('ontouchstart' in window) &&
                !navigator.msMaxTouchPoints &&
                !navigator.userAgent.toLowerCase().match( /windows phone os 7/i )) return false;

            if (action === 'unbind') {
                this.each(function() {
                    $(this).off();
                    $(document).off('click touchstart MSPointerDown', handleTouch);
                });

            } else {
                this.each(function() {
                    var curItem = false;

                    $(this).on('click', function(e) {
                        var item = $(this);
                        if (item[0] != curItem[0]) {
                            e.preventDefault();
                            curItem = item;
                        }
                    });

                    $(document).on('click touchstart MSPointerDown', handleTouch);

                    function handleTouch(e) {
                        var resetItem = true,
                            parents = $(e.target).parents();

                        for (var i = 0; i < parents.length; i++)
                            if (parents[i] == curItem[0])
                                resetItem = false;

                        if(resetItem)
                            curItem = false;
                    }
                });
            }
            return this;
        };
    })(jQuery, window, document);
    $('#navbar:has(ul)').doubleTapToGo();

    $('.zoom-view-big').click(function(){
        var baseFontSize = parseInt($('html').css('font-size'));
        if (baseFontSize < 12) {
            $('html').css('font-size', "+=1");
        }
    })

    $('.zoom-view-small').click(function(){
        var baseFontSize = parseInt($('html').css('font-size'));
        console.log(baseFontSize);

        if (baseFontSize > 10) {
            $('html').css('font-size', "-=1");
        }
    })

    $(".fancybox").fancybox();
});

function createReadSpeaker(text)
{
    jQuery.ajax({
        url: 'readspeaker.php',
        type: 'post',
        data: {
            src: '//app-eu.readspeaker.com/cgi-bin/rsent?customerid=9990&amp;lang=de_de&amp;readid=' + text + '&amp;url=' + window.location.href
        },
        success: function(data) {
            jQuery('#' + text).html(jQuery('#' + text).html() + data);
        }
    });
}
